// extracted by mini-css-extract-plugin
export default {"get_it_now_v2":"fk","place_order_copy":"gk","next_order_copy":"hk","title_wrapper":"ik","get_it_now_row":"jk","get_it_now_remaining_items":"kk","get_it_now_remaining_items_mob":"lk","order_summary":"mk","additional_items":"nk","account_content_slider":"ok","ingredient_carousel":"pk","ingredient_carouselwrapper":"qk","account_content_slide":"rk","account_subscription_section_mob":"sk","carouselwrapper":"tk"};
    if(module.hot) {
      // 1715091668710
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  